// extracted by mini-css-extract-plugin
module.exports = {"root":"PasswordResetForm_root__3fuVb"};